import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const FilesPptIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21.53 4.47L17.53 0.47C17.39 0.33 17.2 0.25 17 0.25H4C3.04 0.25 2.25 1.04 2.25 2V22C2.25 22.96 3.04 23.75 4 23.75H20C20.96 23.75 21.75 22.96 21.75 22V5C21.75 4.8 21.67 4.61 21.53 4.47ZM20.25 22C20.25 22.14 20.14 22.25 20 22.25H4C3.86 22.25 3.75 22.14 3.75 22V2C3.75 1.86 3.86 1.75 4 1.75H16.69L20.25 5.31V22Z"
        fill={color}
      />
      <path
        d="M12 7.38C8.35 7.38 5.38 10.35 5.38 14C5.38 17.65 8.35 20.62 12 20.62C15.65 20.62 18.62 17.65 18.62 14C18.62 10.35 15.65 7.38 12 7.38ZM12 19.38C9.04 19.38 6.62 16.97 6.62 14C6.62 11.25 8.7 9 11.37 8.69V14C11.37 14.17 11.44 14.33 11.55 14.44L15.31 18.2C14.39 18.92 13.25 19.38 12 19.38ZM16.2 17.31L13.3 14.41L17.35 13.74C17.47 15.06 16.96 16.34 16.2 17.31ZM12.62 13.26V8.69C14.78 8.94 16.54 10.47 17.13 12.51L12.62 13.26Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

FilesPptIcon.displayName = 'FilesPptIcon';
